import { Show, ShowStatus } from "@quantizr-engineering/common/types/show";

export const isShowInActualStatus = (show: Show) => {
  if (show.status === ShowStatus.SETTLED || show.status === ShowStatus.PAID) {
    return true;
  } else {
    return false;
  }
};

export const STATUS_CONFIG = {
  [ShowStatus.DRAFT]: {
    step: 1,
    color: "bg-[#7D7899]",
  },
  [ShowStatus.CONFIRMED]: {
    step: 2,
    color: "bg-[#6D53FD]",
  },
  [ShowStatus.SETTLED]: {
    step: 3,
    color: "bg-[#0D5F7F]",
  },
  [ShowStatus.PAID]: {
    step: 4,
    color: "bg-[#054F36]",
  },
} as const;

export const getStatusStyling = (
  status: ShowStatus,
): string => {
  const bgColors = {
    [ShowStatus.DRAFT]: "bg-[#E9E8ED] text-[#48455B]",
    [ShowStatus.CONFIRMED]: "bg-[#F1E5FF] text-[#4932F5]",
    [ShowStatus.SETTLED]: "bg-[#E2F4FC] text-[#0D5F7F]",
    [ShowStatus.PAID]: "bg-[#D1FAE2] text-[#054F36]",
  };
  return bgColors[status] ?? bgColors[ShowStatus.DRAFT];
};
